export const getBrowserLocale = () => {
  const navigatorLanguage = navigator.languages ? navigator.languages[0] : navigator.language;
  // Check if we got a valid language from the browser otherwise set a default
  return navigatorLanguage.length >= 2 ? navigatorLanguage : 'de-DE';
};
